
define('text!templates/modules/questionnaire/responses/answers/answer-comment-form.html',[],function () { return '<div class="results-comment-form">\n    <div class="comment-input"></div>\n</div>\n';});

